/**
 * 이미지 소스 URL 결정 함수
 * 다양한 상태와 조건에 따라 최종적으로 사용할 이미지 URL을 결정
 */ export var resolveImageSource = function(options) {
    var mainImgError = options.mainImgError, fallbackSrc = options.fallbackSrc, internalBlobUrl = options.internalBlobUrl, imageBlob = options.imageBlob, src = options.src, processImageUrl = options.processImageUrl;
    // 메인 이미지 오류 시 대체 이미지 사용
    if (mainImgError) {
        return fallbackSrc || '';
    }
    // Blob 객체에서 생성한 내부 URL 우선 사용
    if (internalBlobUrl && imageBlob) {
        return internalBlobUrl;
    }
    // src가 유효하고 placeholder가 아닌 경우 URL 가공 처리
    if (src && src !== '_placeholder_') {
        return processImageUrl(src);
    }
    // 그 외의 경우 대체 이미지 사용
    return fallbackSrc || '';
};
/**
 * 대체 이미지 경로 생성 함수
 * 환경이나 테마에 따라 적절한 대체 이미지 경로 반환
 */ export var getDefaultImagePath = function(options) {
    var _ref = options || {}, _ref_theme = _ref.theme, theme = _ref_theme === void 0 ? 'light' : _ref_theme, _ref_type = _ref.type, type = _ref_type === void 0 ? 'general' : _ref_type;
    // 기본 이미지 경로
    var basePath = '/assets/images';
    // 타입별 적절한 이미지 선택
    switch(type){
        case 'profile':
            return "".concat(basePath, "/profile-placeholder").concat(theme === 'dark' ? '-dark' : '', ".png");
        case 'post':
            return "".concat(basePath, "/post-placeholder").concat(theme === 'dark' ? '-dark' : '', ".png");
        case 'general':
        default:
            return "".concat(basePath, "/placeholder").concat(theme === 'dark' ? '-dark' : '', ".png");
    }
};
